
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neet-pg",
      function () {
        return require("private-next-pages/neet-pg.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neet-pg"])
      });
    }
  